import axios from '../../../../axiosRetailReleases';

const currentURL = window.location.href;
const url = new URL(currentURL);
const domain = url.origin;

// danh sach danh mục sản phẩm
const getListCategory = (data, header) => {
    return axios({
        url: '/category-product/list',
        method: 'POST',
        data: {
            ...data,
            link: '/category',
            domain: domain,
        },
        headers: header,
    });
};

// danh mục cha trong màn sản phẩm
const getListCategoryParent = (header, data = {}) => {
    return axios({
        url: '/category-product/list-parent',
        method: 'POST',
        data: {
            ...data,
            link: '/category',
            domain: domain,
        },
        headers: header,
    });
};

export { getListCategory, getListCategoryParent };
